function toggleEducationPrograms() {
  const buttonStandart = $('.education-programs__button-one')
  const buttonPremium = $('.education-programs__button-two')
  const rateStandatr = $('.education-programs__package-one')
  const ratePremium = $('.education-programs__package-two')
  const titleStandart = $('.education-programs__content-one')
  const titlePremium = $('.education-programs__content-two')

  buttonPremium.on('click', function() {
    $(this).parent().addClass('active');
    ratePremium.addClass('active');
    titlePremium.addClass('active');
    rateStandatr.removeClass('active');
    titleStandart.removeClass('active');
  })
  buttonStandart.on('click', function() {
    $(this).parent().removeClass('active');
    ratePremium.removeClass('active');
    titlePremium.removeClass('active');
    rateStandatr.addClass('active');
    titleStandart.addClass('active');
  })
}
toggleEducationPrograms()